'use client';

import { c as _c } from "react/compiler-runtime";
import { MouseEvent, ReactNode } from 'react';
import clsx from 'clsx';
import { GetPathNameArgs, Link } from '@/i18n/navigation';
type SuggestionLinkItemProps = {
  href: GetPathNameArgs['href'];
  /** Renders the group heading above the first item of a group. */
  groupLabel?: string;
  /** Separates the last item of a group from the group below. */
  showDivider?: boolean;
  /** Navigates to the target page — also resets the search field. */
  onNavigate: () => void;
  dataTracking: string;
  children: ReactNode;
};

/** A ComboBox suggestion that is a real link into the shop instead of a search term. */
export const SuggestionLinkItem = t0 => {
  const $ = _c(15);
  const {
    href,
    groupLabel,
    showDivider,
    onNavigate,
    dataTracking,
    children
  } = t0;
  let t1;
  if ($[0] !== onNavigate) {
    t1 = event => {
      event.stopPropagation();
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
        return;
      }
      event.preventDefault();
      onNavigate();
    };
    $[0] = onNavigate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClick = t1;
  const t2 = showDivider && "-mb-3 border-b border-neutral-300 pb-3";
  let t3;
  if ($[2] !== t2) {
    t3 = clsx("-mx-3 block px-3", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== groupLabel) {
    t4 = groupLabel && <span className="mb-1 block text-xs font-medium tracking-wide text-neutral-700 uppercase" aria-hidden={true}>{groupLabel}</span>;
    $[4] = groupLabel;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== dataTracking || $[8] !== handleClick || $[9] !== href) {
    t5 = <Link className="flex items-center gap-2" href={href} data-tracking={dataTracking} onClick={handleClick} tabIndex={-1}>{children}</Link>;
    $[6] = children;
    $[7] = dataTracking;
    $[8] = handleClick;
    $[9] = href;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <span className={t3}>{t4}{t5}</span>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};